import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  idp: string = environment.identityProvider;

  constructor(private auth: AuthService, private router: Router) { }

  async ngOnInit() {
    console.log('checking auth from login component');
    if (await this.auth.isAuthenticated()) {
      console.log('navigating to home');
      this.router.navigate(['/home']);
    }
  }
}
